export * from './platformFee.service';
import { PlatformFeeService } from './platformFee.service';
export const APIS = [PlatformFeeService];
